module.exports = __webpack_public_path__ + "static/media/carousel1.e57ddfc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/carousel1.png
// module id = 1226
// module chunks = 0